module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"OUTPUT_1":"Channel 1","OUTPUT_2":"Channel 2"},"de":{"OUTPUT_1":"Kanal 1","OUTPUT_2":"Kanal 2"},"fr":{"OUTPUT_1":"Canal 1","OUTPUT_2":"Canal 2"},"it":{"OUTPUT_1":"Canale 1","OUTPUT_2":"Canale 2"}}')
  delete Component.options._Ctor
}
